export const MeasureTypes = {
    LENGTH: 'LENGTH',
    WEIGHT: 'WEIGHT',
    TIME: 'TIME',
    SPEED: 'SPEED',
} as const;

export const LengthUnits = {
    FEET_INCHES: 'FEET_INCHES',
    METERS: 'METERS',
} as const;

export const WeightUnits = {
    LBS: 'LBS',
    KG: 'KG',
} as const;

export const TimeUnits = {
    HH_MM_SS: 'HH_MM_SS',
    MM_SS_SSS: 'MM_SS_SSS',
    SS_SSS: 'SS_SSS',
} as const;

export const SpeedUnits = {
    MPH: 'MPH',
    KPH: 'KPH',
} as const;

export const UnitOptions = {
    [MeasureTypes.LENGTH]: Object.values(LengthUnits),
    [MeasureTypes.WEIGHT]: Object.values(WeightUnits),
    [MeasureTypes.TIME]: Object.values(TimeUnits),
    [MeasureTypes.SPEED]: Object.values(SpeedUnits),
} as const;

export const PointScales = {
    SCORE: 'SCORE',
    PERFORMANCE: 'PERFORMANCE',
} as const;

export const ScoreScaleOptions = {
    FIVE_POINT: 'FIVE_POINT',
    TEN_POINT: 'TEN_POINT',
} as const;

export const ScoreScaleValues = {
    [ScoreScaleOptions.FIVE_POINT]: 5,
    [ScoreScaleOptions.TEN_POINT]: 10,
} as const;

export const EvaluationSkillSections = ['Athleticism', 'Skills', 'Awareness', 'Intangibles'];
